import { render } from "./Breakdown2.vue?vue&type=template&id=f6b2ee7c&scoped=true"
import script from "./Breakdown2.vue?vue&type=script&lang=js"
export * from "./Breakdown2.vue?vue&type=script&lang=js"

import "./Breakdown2.vue?vue&type=style&index=0&id=f6b2ee7c&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6b2ee7c"]])

export default __exports__